  <mat-card>
      <mat-card-header>
          <mat-card-title>{{labelAzienda}}</mat-card-title>
      </mat-card-header>
      <mat-card-content class="content">

        <form [formGroup]="registerForm" (ngSubmit)="save()">

          <mat-form-field [style.display]="getConfigurazione().Nome" class="example-full-width">
            <mat-label class="text-sm">Nome</mat-label>
            <input matInput placeholder="Nome" formControlName="Nome" name="Nome" required>
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Partitaiva" class="example-full-width">
            <mat-label class="text-sm">Partita IVA</mat-label>
            <input matInput placeholder="Partitaiva" formControlName="Partitaiva" name="Partitaiva">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Codicefiscale" class="example-full-width">
            <mat-label class="text-sm">Codice fiscale</mat-label>
            <input matInput placeholder="Codicefiscale" formControlName="Codicefiscale" name="Codicefiscale">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Email" class="example-full-width">
            <mat-label class="text-sm">email</mat-label>
            <input matInput placeholder="Email" formControlName="Email" name="Email">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Pec" class="example-full-width">
            <mat-label class="text-sm">PEC</mat-label>
            <input matInput placeholder="Pec" formControlName="Pec" name="Pec">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Telefono" class="example-full-width">
            <mat-label class="text-sm">Telefono</mat-label>
            <input matInput placeholder="Telefono" formControlName="Telefono" name="Telefono">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Cellulare" class="example-full-width">
            <mat-label class="text-sm">Cellulare</mat-label>
            <input matInput placeholder="Cellulare" formControlName="Cellulare" name="Cellulare">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Svi" class="example-full-width">
            <mat-label class="text-sm">SDI</mat-label>
            <input matInput placeholder="Sdi" formControlName="Sdi" name="Sdi">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Missione" class="example-full-width">
            <mat-label class="text-sm">Missione</mat-label>
            <input matInput placeholder="Missione" formControlName="Missione" name="Missione">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Ragionesociale" class="example-full-width">
            <mat-label class="text-sm">Ragione sociale</mat-label>
            <input matInput placeholder="Ragione sociale" formControlName="Ragionesociale" name="Ragionesociale">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Attivita" class="example-full-width">
            <mat-label class="text-sm">Attivita</mat-label>
            <input matInput placeholder="Attivita" formControlName="Attivita" name="Attivita">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Numerodipendenti" class="example-full-width">
            <mat-label class="text-sm">Numero dipendenti</mat-label>
            <input matInput placeholder="Numero dipendenti" formControlName="Numerodipendenti" name="Numerodipendenti">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Rea" class="example-full-width">
            <mat-label class="text-sm">Rea</mat-label>
            <input matInput placeholder="Rea" formControlName="Rea" name="Rea">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Datarea" appearance="fill">
            <mat-label class="text-sm">Data Rea</mat-label>
             <input matInput
              [matDatepicker]="picker" placeholder="Datarea" name="Datarea" formControlName="Datarea"/>
             <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
             <mat-datepicker #picker></mat-datepicker>
         </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Cameracommercio" class="example-full-width">
            <mat-label class="text-sm">Camera commercio</mat-label>
            <input matInput placeholder="Cameracommercio" formControlName="Cameracommercio" name="Cameracommercio">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Codice" class="example-full-width" [hidden]=true>
            <mat-label class="text-sm">Codice</mat-label>
            <input matInput placeholder="Codice" formControlName="Codice" name="Codice">
          </mat-form-field>




          <mat-form-field class="example-full-width" [style.display]="'none'">
            <mat-label class="text-sm">Tipo relazione</mat-label>
            <input matInput placeholder="Tipo relazione" formControlName="Tiporelazione" name="Tiporelazione">         
          </mat-form-field>

      
         

    

        <table>
          <tr>
            <td>
              <mat-label style="width:70%; font-size: 18px; font-family: Roboto; font-weight: bold" class="text-sm">Lista delle sedi</mat-label>
            </td>
          </tr>
        </table>
        <br>

        
      <table>
          <tr>
            <td>
              <mat-form-field appearance="fill">
                <mat-label class="text-sm">Nome sede</mat-label>
                <input matInput placeholder="Nome sede" formControlName="Nomesede" name="Nomesede" required>         
              </mat-form-field>
            </td>
            <td>
              <mat-form-field appearance="fill">
                <mat-label class="text-sm">Indirizzo</mat-label>
                <input matInput placeholder="Indirizzo" formControlName="Indirizzo" name="Indirizzo" required="">         
              </mat-form-field>
            </td>
            <td>
              <mat-form-field appearance="fill">
                <mat-label class="text-sm">CAP - {{ nomeComune }}</mat-label>
                <input
                  matInput
                  [matAutocomplete]="autocap"
                  (keyup)="onFiltroCapKeyup($event)"
                  formControlName="Cap" required
                />                    
              <mat-autocomplete #autocap="matAutocomplete" (optionSelected)="onCapSelected($event)">
                <mat-option
                          *ngFor="let comune of comunifiltrati | async"
                          [value]="comune.Cap">
                          <span>{{ comune.Cap+' - '+comune.Nome }}</span>
                </mat-option>
                </mat-autocomplete>
              </mat-form-field>
             </td>
             <td>
              <button mat-raised-button  color="primary" (click)="saveSede()">Aggiungi sede</button>
             </td>
          </tr>
        </table>   

     
    </form>

    
       
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

          <ng-container matColumnDef="Nome">
              <th mat-header-cell *matHeaderCellDef> Nome </th>
              <td mat-cell *matCellDef="let sede"> {{sede.Nome}} </td>
          </ng-container>

          <ng-container matColumnDef="Indirizzo">
              <th mat-header-cell *matHeaderCellDef> Indirizzo </th>
              <td mat-cell *matCellDef="let sede"> {{sede.Indirizzo}} </td>
          </ng-container>

          <ng-container matColumnDef="Cap">
              <th mat-header-cell *matHeaderCellDef> CAP </th>
              <td mat-cell *matCellDef="let sede"> {{sede.Cap}} </td>
          </ng-container>

          <ng-container matColumnDef="Nomecomune">
              <th mat-header-cell *matHeaderCellDef> Comune </th>
              <td mat-cell *matCellDef="let sede"> {{sede.Nomecomune}} </td>
          </ng-container>

          <ng-container matColumnDef="elimina">
              <th mat-header-cell *matHeaderCellDef> Elimina </th>
              <td mat-cell *matCellDef="let sede">
                <mat-icon  color="primary" (click)="eliminaSede(sede)">delete</mat-icon>
              </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>


      </mat-card-content>
      <mat-card-actions>
        <table>
          <tr>
            <td>
              <button mat-raised-button  color="primary" (click)="save()">Salva</button>
            </td>

            <td>
              <button mat-raised-button  color="primary" (click)="cancel()">Indietro</button>
            </td>
          </tr>
        </table>
      </mat-card-actions>

  </mat-card>
